export default __webpack_public_path__ + "static/media/startlater_1.e7080d30.jpg";